import { Col, Label, ListGroup, ListGroupItem } from "reactstrap";

const DetailPetunjukUmum = ({ colSM, className, petunjukUmum }) => {
  return (
    <Col sm={colSM} className={className}>
      <Label>Petunjuk Umum</Label>
      <ListGroup numbered style={{ border: "none" }}>
        {petunjukUmum.map((row) => (
          <ListGroupItem style={{ border: "none" }}>{row}</ListGroupItem>
        ))}
      </ListGroup>
    </Col>
  );
};

export default DetailPetunjukUmum;
